var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "17px",
    viewBox: "0 0 23 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "52E42E73-8609-46EE-9B43-11BB1BEE25ED") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HK---Payment-Details---Filled-Out",
    transform: "translate(-184.000000, -489.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Credit-Card-info",
    transform: "translate(24.000000, 449.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Credit-Card-Section",
    transform: "translate(118.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cc-icon-copy",
    transform: "translate(42.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1B1C1F",
    fill: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 15.1,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1B1C1F",
    x: 13.8,
    y: 10.35,
    width: 6.9,
    height: 2.3,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1B1C1F",
    x: 0.15,
    y: 3.45,
    width: 22,
    height: 4.6
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.bb6da007eb6569d1b51e5c40d2a54ccd.svg";
export { ForwardRef as ReactComponent };